var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"rowindex state-disabled",attrs:{"width":"5%"}},[_c('b',[_vm._t("after"),_vm._v(" "+_vm._s(_vm.index + 1)+". "),_vm._t("before")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }